export enum ApiLoadingStatus {
  "IDLE" = "IDLE",
  "LOADING" = "LOADING",
  "SUCCESS" = "SUCCESS",
  "FAILED" = "FAILED",
}
